import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setTiposPublicacion } from '../actions/tiposPublicacionActions';
import Auth from '../auth';
import ClickOutsideHandler from './General/ClickOutsideHandler';
import { getSeller } from '../api/axios';

// Wrapper para usar hooks en class component
function MenuWrapper(props) {
  const navigate = useNavigate();
  return <Menu {...props} navigate={navigate} />;
}

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideLogout: true,
            nombreTienda: "",
            urlLogo: ""
        };
    }

    componentDidMount() {
        this.getSellerData();
    }

    async getSellerData() {
        const id = this.props.idSeller;
        if (!id || Number(id) <= 0) return;
        try {
            const res = await getSeller(id);
            const seller =
                res?.paginateSellers?.elementos?.[0] ??
                res?.PaginateSellers?.Elementos?.[0] ??
                res?.seller ??
                res?.Seller;
            if (!seller) return;

            let nombreTienda = "";
            if (seller.nombreTienda) {
                if (seller.nombreTienda.length < 20) {
                    nombreTienda = seller.nombreTienda;
                } else {
                    nombreTienda = seller.nombreTienda.substring(0, 20) + "...";
                }
            } else {
                nombreTienda = seller.razonSocial;
            }

            this.setState({
                nombreTienda: nombreTienda || "",
                urlLogo: seller.logo || seller.urlLogo || ""
            });
        } catch (e) {
            return;
        }
    }

    handleClickOutside = () => {
        this.setState({ hideLogout: true });
    };

    onLogout() {
        this.setState({ hideLogout: true });
        Auth.logout();
        this.props.navigate("/login")
    }

    stopImpersonation = () => {
        this.setState({ hideLogout: true });
        const restored = Auth.stopImpersonation();
        if (restored) {
            toast.success("Volviste a tu sesion original");
            this.props.navigate("/");
            return;
        }

        toast.warn("No se pudo restaurar la sesion original. Volve a iniciar sesion.");
        this.props.navigate("/login");
    }

    goToEditProfile = () => {
        this.setState({ hideLogout: true });
        this.props.setTiposPublicacion([{}]);
        this.props.navigate(`/Sellers/Editar/${this.props.idSeller}`);
    }

    toggleMenu = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState((prev) => ({ hideLogout: !prev.hideLogout }));
    };

    render() {
        const { hideLogout, urlLogo } = this.state;
        const { impersonation } = this.props;
        const isSeller = this.props.tipoUsuario === 3 || this.props.tipoUsuario === 4;
        const isImpersonating = !!impersonation?.isActive;

        return (
            <div
                className="allow-pointer-cursor prevent-select menu-user-header"
                style={{ position: "relative", zIndex: 3000 }}
            >
                <ClickOutsideHandler onClickOutside={this.handleClickOutside}>
                    <div className="position-relative d-inline-flex flex-column align-items-end">
                        <div
                            className="nav-link dropdown-toggle waves-effect waves-dark profile-pic d-flex align-items-center"
                            onClick={this.toggleMenu}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    this.toggleMenu(e);
                                }
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            {isSeller && (
                                <div className="me-2 flex-shrink-0">
                                    <img className="avatar-logo rounded-circle" src={urlLogo} alt="" />
                                </div>
                            )}
                            <h6 className="d-inline color-blanco-megatone hidden-md-down px-1 mt-1 mb-0">
                                {isSeller ? this.state.nombreTienda : this.props.userName}
                            </h6>
                            {isImpersonating && (
                                <span className="badge rounded-pill bg-warning text-dark ms-1">
                                    Impersonando
                                </span>
                            )}
                            <i className="fa fa-angle-down color-blanco-megatone px-1" aria-hidden />
                        </div>

                        {!hideLogout && (
                            <div
                                className="dropdown-menu-custom position-absolute end-0 bg-white border rounded shadow mt-1 p-0"
                                style={{ top: "100%", zIndex: 3002, minWidth: "12rem" }}
                                role="menu"
                            >
                                <div
                                    className="dropdown-item p-2 hover-background-color d-flex align-items-center"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.goToEditProfile();
                                    }}
                                >
                                    <i className="color-gris-megatone fa fa-user me-2" /> Mi Perfil
                                </div>

                                {isImpersonating && (
                                    <div
                                        className="dropdown-item p-2 hover-background-color d-flex align-items-center text-danger"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.stopImpersonation();
                                        }}
                                    >
                                        <i className="color-gris-megatone fa fa-user-secret me-2" /> Salir de impersonacion
                                    </div>
                                )}

                                <div
                                    className="dropdown-item p-2 hover-background-color d-flex align-items-center"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.onLogout();
                                    }}
                                >
                                    <i className="color-gris-megatone fa fa-power-off me-2" /> Salir
                                </div>
                            </div>
                        )}
                    </div>
                </ClickOutsideHandler>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    userName: state.general.userName,
    impersonation: state.general.impersonation
})

export default connect(mapStateToProps, { setTiposPublicacion })(MenuWrapper);
